import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-one-about',
  templateUrl: './agency-one-about.component.html',
  styleUrls: ['./agency-one-about.component.scss']
})
export class AgencyOneAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
